import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initCounterElements() {
	const counters = document.querySelectorAll('.js-counter');

	if (!counters.length) {
		return;
	}

	counters.forEach((counter) => {
		const target = Number(counter.dataset.counterValue || 0);

		if (Number.isNaN(target)) {
			return;
		}

		const proxy = {
			value: 0,
		};

		ScrollTrigger.create({
			trigger: counter,
			start: 'top 85%',
			once: true,
			onEnter: () => {
				gsap.to(proxy, {
					value: target,
					duration: 1.2,
					ease: 'power3.out',
					onUpdate: () => {
						counter.textContent = Math.round(proxy.value).toLocaleString('it-IT');
					},
					onComplete: () => {
						counter.textContent = Math.round(target).toLocaleString('it-IT');
					},
				});
			},
		});
	});
}